import React, { useContext } from "react";
import { SliderContext } from "./App";
import { AppContext } from "../window";
import { useTranslation } from "../i18n";
import ChatIcon from "@mui/icons-material/Chat";
import AppAvatar from "../libs/AppAvatar";
import { useNavigate } from "react-router";

interface FavoriteModalProps {
  // Whether the user was already a favorite before the current action
  wasFavorite?: boolean;
}

export const FavoriteModal: React.FC<FavoriteModalProps> = ({ wasFavorite = false }) => {
  const { t } = useTranslation();
  const { texts } = useContext(AppContext);
  const { user, legacyMode } = useContext(SliderContext);
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  return (
    <div className="favorite">
      <div className="d-flex justify-content-center mb-3">
        <AppAvatar src={user.displayPicture.thumb} circle pulsingBorder pulsingBorderColor="success" size="xxl" />
      </div>
      <p className="text-center w-100 mb-3">
        {wasFavorite
          ? t('slider.already_favorite', { nickname: user.nickname })
          : t('slider.added_to_favorites').replace('%nickname%', user.nickname)}
      </p>
      <div className="text-center">
        {legacyMode ? (
          <a href={`/chat/conversation/v2?uid=${user.id}`} className="py-2 px-4 btn btn-danger">
            <ChatIcon fontSize="large" /> {t('slider.chat_now')}
          </a>
        ) : (
          <button 
            onClick={() => navigate(`/inbox/${user.id}`)} 
            className="py-2 px-4 btn btn-danger"
          >
            <ChatIcon fontSize="large" /> {t('slider.chat_now')}
          </button>
        )}
      </div>
    </div>
  );
};


